import React from 'react';
import { FaGoogle} from "react-icons/fa";


const Offer = () => {
  return (
    <div>
         {/* EXCITING OFFERS SECTION STARTS HERE */}
        <section class="exciting">
            <h2>Grab These Exciting Offers And Apply Now</h2>

            <div class="offers">

                <div class="offer1">
                    <div class="google">
                        <div class="g-l">
                            <FaGoogle className='google-icon'/>
                        </div>
                        <div class="g-r">
                            <h4>Google, Nigeria</h4>
                            <h3>Product Designer</h3>
                            <p>Posted 45 mins ago</p>
                            <h5>We are searching for a Junior Designer for our team. </h5>
                        </div>
                    </div>
                    <div class="apply">
                        <a href="">Apply Now</a>
                    </div>
                </div>

                <div class="offer1">
                    <div class="google">
                        <div class="g-l">
                            <FaGoogle className='google-icon'/>
                        </div>
                        <div class="g-r">
                            <h4>Google, Nigeria</h4>
                            <h3>Product Designer</h3>
                            <p>Posted 45 mins ago</p>
                            <h5>We are searching for a Junior Designer for our team. </h5>
                        </div>
                    </div>
                    <div class="apply">
                        <a href="">Apply Now</a>
                    </div>
                </div>

                <div class="offer1">
                    <div class="google">
                        <div class="g-l">
                            <FaGoogle className='google-icon'/>
                        </div>
                        <div class="g-r">
                            <h4>Google, Nigeria</h4>
                            <h3>Product Designer</h3>
                            <p>Posted 45 mins ago</p>
                            <h5>We are searching for a Junior Designer for our team. </h5>
                        </div>
                    </div>
                    <div class="apply">
                        <a href="">Apply Now</a>
                    </div>
                </div>


                <div class="offer1">
                    <div class="google">
                        <div class="g-l">
                            <FaGoogle className='google-icon'/>
                        </div>
                        <div class="g-r">
                            <h4>Google, Nigeria</h4>
                            <h3>Product Designer</h3>
                            <p>Posted 45 mins ago</p>
                            <h5>We are searching for a Junior Designer for our team. </h5>
                        </div>
                    </div>
                    <div class="apply">
                        <a href="">Apply Now</a>
                    </div>
                </div>

                
            </div>
                    <div class="apply">
                        <a href="">Browse All</a>
                    </div>
        </section>

     {/* EXCITING OFFERS SECTION ENDS HERE */}

    </div>
  )
}

export default Offer